module.exports = __webpack_public_path__ + "img/product-five-2.15e9bea4.png";